import { useState, useEffect } from 'react';

const getOrientation = () => {
  try {
    return window.screen.orientation.type;
  } catch (e) {
    return null;
  }
};

const useScreenOrientation = () => {
  const [orientation, setOrientation] = useState(getOrientation());

  const updateOrientation = () => {
    setOrientation(getOrientation());
  };

  useEffect(() => {
    try {
      window.addEventListener('orientationchange', updateOrientation);
      return () => {
        window.removeEventListener('orientationchange', updateOrientation);
      };
    } catch (e) {
      return () => {};
    }
  }, []);

  return orientation;
};

export default useScreenOrientation;
